import React from 'react';
import { useStripe, useElements, CardElement } from '@stripe/react-stripe-js';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import CardSection from './CardSection';
import { Box, Button, Paper } from '@mui/material';
import { useState } from 'react';
export default function CheckoutForm() {
	const stripe = useStripe();
	const elements = useElements();
	const navigate = useNavigate();
	const [stripeData, setStripeData] = useState(null);
	const handleSubmit = async event => {
		// We don't want to let default form submission happen here,
		// which would refresh the page.
		event.preventDefault();

		if (!stripe || !elements) {
			// Stripe.js hasn't yet loaded.
			// Make  sure to disable form submission until Stripe.js has loaded.
			return;
		}

		const card = elements.getElement(CardElement);
		const result = await stripe.createToken(card);

		if (result.error) {
			// Show error to your customer.
			console.log(result.error.message);
			toast.error(result.error.message);
		} else {
			// try {

			var firstToken = localStorage.getItem('token');
			var secondToken = JSON.parse(localStorage.getItem('cogen_user_profile'))?.accessToken;
			var tokenToUse;
			if (firstToken === null) {

				tokenToUse = secondToken;
			} else {

				tokenToUse = firstToken;
			}
			axios
				.post(
					'https://api.getcogen.com/api/clientBillingInfoAndPay',
					{ stripe_token: result.token.id },
					{
						headers: {
							Accept: 'application/json',
							Authorization: `Bearer ${tokenToUse} `,
						},
					}
				)
				.then(response => {
					setStripeData(response);
					toast.success(response.data.message);
					if (response.data.success === true) {
						navigate('/');
					}
				})
				.catch(error => {
					toast.error(error.response?.data?.message);
				});
			// Send the token to your server.
			// This function does not exist yet; we will define it in the next step.
			// stripeTokenHandler	(result.token);
		}
	};

	return (
		<form onSubmit={handleSubmit}>
			<Box
				sx={{
					display: 'flex',
					justifyContent: 'center',
					alignItems: 'center',
					flexDirection: 'column',
					minHeight: '100vh',
				}}
			>
				<Paper elevation={2} sx={{ p: 3, bgcolor: '#F5F5F5' }}>
					<CardSection />
					<Button
						type='submit'
						sx={{ mt: 1 }}
						variant='contained'
						color='success'
						disabled={!stripe}
					>
						{' '}
						Pay Amount
					</Button>
				</Paper>
			</Box>
		</form>
	);
}
